import { Component, OnInit } from '@angular/core';
import { Regex, CacheConstant } from '../../../core/constants/app.constant';
import { OktaService } from '../okta.service';
import { PublisherService } from '../../../core/services/publisher.service';
import { NgForm } from '@angular/forms';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { HttpError } from '../../../shared/models/http-error';
import { OktaConstant } from '../okta.constant';
import { BaseComponent } from '../../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { AppConfigService } from '../../../core/services/init/app-config.service';
// import { Feedback, FeedbackType } from "nativescript-feedback";

@Component({
  selector: 'par-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends BaseComponent implements OnInit {
  /***************Properties***************/
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  pwdStatus: string = this.cache.get(CacheConstant.Pwd_Dtl);
  pwdExpired: boolean = false;
  // private feedback: Feedback;
  messages: any = {
    passwordHint: OktaConstant.Messages.ChangePasswordHintMessage
  };
  validation: any = {
    passwordRegex: Regex.Password
  };
  change: any = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    pattern: Regex.Password,
    errorMessage: ''
  };
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    private oktaService: OktaService,
    deviceDetectorService: DeviceDetectorService,
    private router: Router,
    private appConfig: AppConfigService
  ) {
    super(deviceDetectorService, cache, appConfig);
    // this.feedback = new Feedback();
  }

  ngOnInit() {
    PublisherService.changeBannerHeader('Change Password');
    if(this.pwdStatus === 'expired') {
      this.pwdExpired = true;
    }
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onCancelClick() {
    if (!this.isMobileDevice()) {
      AppUtilService.redirectToHome();
    } else {
      AppUtilService.redirectToHomeMobile();
    }
  }

  onChangePasswordSubmit(form: NgForm) {
    if (form.invalid) {
      return;
    }

    this.change.errorMessage = '';
    this.oktaService
      .changePassword(this.change.oldPassword, this.change.newPassword)
      .subscribe((response: any) => {
        if (response && response.hasError) {
          this.change.errorMessage = AppUtilService.resolveErrorResponse(
            response as HttpError
          ).messageText;
        } else {
          AppUtilService.message.success(
            OktaConstant.Messages.ChangePasswordSuccessMesssage
          );
          AppUtilService.cache.set(CacheConstant.Pwd_Dtl,
            "active"
          );
          AppUtilService.redirectToHome();
        }
      });
  }

  onAppChangePasswordSubmit() {
    this.change.errorMessage = '';
    this.oktaService
      .changePassword(this.change.oldPassword, this.change.newPassword)
      .subscribe((response: any) => {
        if (response && response.businessFault) {
          this.change.errorMessage = AppUtilService.resolveErrorResponse(
            response as HttpError
          ).messageText;
        } else {
          // this.feedback.show({
          //   message: OktaConstant.Messages.ChangePasswordSuccessMesssage,
          //   type: FeedbackType.Success
          // });
          this.router.navigate(['/']);
        }
      });
  }

  /***************Component Methods***************/
}
